import { useState } from 'react';
import { useLocation } from 'react-router-dom';
import CustomList from '../../../core/components/core/Util/List/CustomList/CustomList';
import CustomListContainer from '../../../core/components/core/Util/List/CustomList/CustomListContainer';
import CancelSale from './Modals/CancelSale';
import { loadData } from '../../../core/components/core/Util/List/CustomList/loadData';
import config from '../../config/config';
import { chooseProfileFilter } from '../../helpers/chooseProfileFilter';
import { useDispatch } from 'react-redux';
import Toast from "../../../core/components/core/Util/Toast/Toast";
import Fetch from '../../../core/util/core/Fetch';

function List() {
    const location = useLocation();
    const isPreSale = location.pathname.includes('/pre-sales/');
    const dispatch = useDispatch();

    const profileFilter = chooseProfileFilter();

    dispatch({ type: 'UPDATE_SESSION', key: 'custom_list_reload', value: new Date() });

    const [showCancelModal, setShowCancelModal] = useState(false);
    const [selectedSale, setSelectedSale] = useState(null);

    const openCancelModal = (sale) => {
        setSelectedSale(sale);
        setShowCancelModal(true);
    };

    const closeCancelModal = () => {
        setSelectedSale(null);
        setShowCancelModal(false);
    };

    const pathFrontEnd = isPreSale ? '/gci/pre-sales/' : '/gci/sales/';
    const endpointBackend = config.endpoints.backend;

    const paths = {
        pathAdd: pathFrontEnd + 'add',
        pathEdit: pathFrontEnd + 'edit',
        pathView: pathFrontEnd + 'view',
        endpointDelete: `${endpointBackend}gci/sales/delete`,
        endpointGetAllRealState: `${endpointBackend}gci/real-state/getall`,
        endpointGetAllProjects: `${endpointBackend}gci/projects/getall`,
        endpointGetAllCompanies: `${endpointBackend}gci/companies/getall`,
        endpoint: `${endpointBackend}gci/sales/getall`
    }

    const filters = {
        validateOnChange: true,
        showGoBackButton: false,
        showSubmitButton: false,
        handleSubmit: loadData,
        fields: [
            !profileFilter.gci_company_id ? {
                name: 'gci_company_id',
                type: 'select',
                label: 'Empresa',
                options: [],
                optionsEndpoint: {
                    endpoint: paths.endpointGetAllCompanies,
                    label: 'name',
                    value: 'id'
                },
                validations: {
                    required: false
                },
                columnSize: 3
            } : {},
             !profileFilter.gci_company_id ? {
                name: 'typeSelected',
                type: 'select',
                label: 'Status',
                options: [
                    { label: 'Pré-Venda', value: 'pre-sale' },
                    { label: 'Pré-Venda Reprovada', value: 'pre-sale-reproved' },
                    { label: 'Venda', value: 'sale' }
                ],
                validations: {
                    required: false
                },
                columnSize: 3
            } : {},
            {
                name: 'gci_project_id',
                type: 'select',
                label: 'Projeto',
                options: [],
                optionsEndpoint: {
                    endpoint: paths.endpointGetAllProjects,
                    label: 'project_name',
                    value: 'id',
                    params: {
                        filter: {
                            ...profileFilter
                        }
                    }
                },
                validations: {
                    required: false
                },
                columnSize: 3
            },
            !profileFilter.gci_real_state_id ? {
                name: 'gci_real_state_id',
                type: 'select',
                label: 'Imobiliária',
                options: [],
                optionsEndpoint: {
                    endpoint: paths.endpointGetAllRealState,
                    label: 'name',
                    value: 'id',
                    params: {
                        filter: {
                            ...profileFilter
                        }
                    }
                },
                validations: {
                    required: false
                },
                columnSize: 3
            } : {},
            {
                name: 'filtro',
                type: 'submit',
                label: 'Pesquisar',
                columnSize: 1
            },
            {
                name: 'reset',
                type: 'reset',
                label: 'Limpar',
                columnSize: 1
            },
        ]
    }

    let list = {
        labelTitle: isPreSale ? 'Lista de Pré-Vendas' : 'Lista de Vendas',
        labelTitleButtonAdd: isPreSale ? 'Incluir nova pré-venda' : 'Incluir nova venda',
        fieldsShowOnDelete: ['unit'],
        formFilters: filters,
        filter: {
            ...profileFilter,
            type: isPreSale ? 'pre-sale' : 'sale'
        },
        canDelete: false,
        columns: [
            {
                name: 'project',
                label: 'Projeto'
            },
            {
                name: 'unit',
                label: 'Unidade'
            },
            {
                name: 'real_state',
                label: 'Imobiliária'
            },
            {
                name: 'business_type',
                label: 'Tipo de Negócio'
            },
            {
                name: 'value',
                label: 'Valor'
            }
        ],
        columnsButtons: [
            {
                buttons: [
                    {
                        label: 'Contrato',
                        icon: 'fas fa-download',
                        onClick: async item => {
                            try {
                                dispatch({ type: 'SHOW_LOADING', value: true });

                                const blob = await Fetch.putBlob(
                                    `${endpointBackend}gci/contract-drafts/generate`,
                                    { gci_sale_id: item.id }
                                );

                                const url = window.URL.createObjectURL(blob);
                                const a = document.createElement('a');
                                a.href = url;
                                a.download = `Contrato ${item.project} ${item.unit}.docx`;
                                document.body.appendChild(a);
                                a.click();
                                a.remove();
                                window.URL.revokeObjectURL(url);
                                Toast.success('Contrato gerado com sucesso');
                            } catch (e) {
                                console.log('Erro ao gerar contrato:', e);
                                Toast.error('Erro ao gerar contrato: ' + e.message);
                            } finally {
                                dispatch({ type: 'SHOW_LOADING', value: false });
                            }
                        },
                        width: '10%'
                    },
                    {
                        label: 'Cancelar',
                        icon: 'fas fa-cancel',
                        onClick: async item => {
                            openCancelModal(item);
                        },
                        width: '10%'
                    }
                ]
            }
        ]
    };

    list = { ...list, ...paths };

    return (
        <div>
            <CustomListContainer
                pathAdd={list.pathAdd}
                labelTitle={list.labelTitle}
                labelTitleButtonAdd={list.labelTitleButtonAdd}
                content={<CustomList list={{ ...list, ...paths }} />}
            />

            {/* --------------------------
                MODAL DE CANCELAMENTO
            --------------------------- */}
            {showCancelModal && (
                <CancelSale
                    show={showCancelModal}
                    onClose={closeCancelModal}
                    saleId={selectedSale?.id}
                />
            )}
        </div>
    );
}

export default List;
